export enum ESessionType {
  Session = "Session",
  Location = "SessionLocation",
  StoryIncrement = "SessionStoryIncrement",
}
